module.exports = __webpack_public_path__ + "img/CS48Q-中_16.c896beef.jpg";